import { NFTSState, INFTS } from '../types';
import { useSelector, shallowEqual } from 'react-redux';

export const useNFTS = () => {
  const nfts: INFTS = useSelector(
    (state: NFTSState) => state.nfts,
    shallowEqual
  );

  return nfts.nfts;
};
